exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/_object-gops.js
// module id = 57
// module chunks = 0